const COLLAPSIBLE_CARD_SELECTOR = 'cbar-card.cbar-filter-card--collapsible';
const TOGGLE_SELECTOR = '.cbar-filter-card-toggle';
const BOUND_ATTR = 'data-cbar-filter-card-collapse-bound';

function setCollapsed(card: Element, toggle: HTMLElement, collapsed: boolean): void {
    card.classList.toggle('is-collapsed', collapsed);
    toggle.setAttribute('aria-expanded', String(!collapsed));
    toggle.setAttribute('aria-label', collapsed ? 'Show filters' : 'Hide filters');
}

function bindFilterCard(card: Element): void {
    if (card.getAttribute(BOUND_ATTR) === 'true') {
        return;
    }

    const toggle = card.querySelector(TOGGLE_SELECTOR) as HTMLElement | null;
    if (!toggle || typeof toggle.addEventListener !== 'function' || typeof toggle.setAttribute !== 'function') {
        return;
    }

    toggle.addEventListener('click', () => {
        setCollapsed(card, toggle, !card.classList.contains('is-collapsed'));
    });

    setCollapsed(card, toggle, card.classList.contains('is-collapsed'));
    card.setAttribute(BOUND_ATTR, 'true');
}

/** Bind expand/collapse for filter cards that use .cbar-filter-card--collapsible. */
export function setupFilterCardCollapse(root: ParentNode = document): void {
    const maybeElement = root as Element;
    if (typeof maybeElement.matches === 'function' && maybeElement.matches(COLLAPSIBLE_CARD_SELECTOR)) {
        bindFilterCard(maybeElement);
    }

    root.querySelectorAll(COLLAPSIBLE_CARD_SELECTOR).forEach((card) => {
        bindFilterCard(card);
    });
}
